// Options for the searchable property dropdown in the parent component.
// Append new system properties here as they are added under sysprop/.
export const SYSTEM_PROPERTY_OPTIONS = [
  { label: 'Deduplication Cache', value: 'deduplication_cache' }
]

// Sysprop name (key) sent to the backend for the deduplication cache property.
export const DEDUP_CACHE_PROPERTY_NAME = 'deduplication_cache_settings'

// Services that have their own enable/ttl override for deduplication cache.
export const DEDUP_CACHE_SERVICES = [
  { key: 'email_verify', label: 'Email Verify' },
  { key: 'data_pulse', label: 'Data Pulse' },
  { key: 'form_guard', label: 'Form Guard' },
  { key: 'email_finder', label: 'Email Finder' },
  { key: 'prospect', label: 'Prospect' },
  { key: 'reverse_lookup', label: 'Reverse Lookup' }
]

export const DEDUP_CACHE_DEFAULT_TTL = 86400
